export default "__VITE_ASSET__xHu33zuQ__"